export const MODULE_NAME = 'nextIntegration';
